export default class EnumQuestion {
  static typeListData = {
    1: "单选题",
    2: "多选题",
    3: "判断题",
    4: "问答题",
    5: "填空题",
    6: "视频问答",
    7: "测评单选",
    101: "通勤时间"
  };
}
